// import https from 'https'

import axios from 'axios'

import {
  authInterceptorRequest,
  authInterceptorResponse,
  authInterceptorResponseError,
} from './interceptors/authInterceptor'
import { getTenantInterceptorRequest } from './interceptors/getTenantInterceptor'

export const httpClient = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
  headers: {
    'Content-Type': 'application/json',
    // 'ngrok-skip-browser-warning': 'true',
  },
})

httpClient.interceptors.request.use((config) => {
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type']
  }
  return config
})

// Request interceptors
httpClient.interceptors.request.use(getTenantInterceptorRequest)
httpClient.interceptors.request.use(authInterceptorRequest)

// Response interceptors
httpClient.interceptors.response.use(
  authInterceptorResponse,
  authInterceptorResponseError,
)
